module.exports = __webpack_public_path__ + "static/hero-sky-4844f005fd89ed8d36f58e07cca22dda.jpg";